import { createFileRoute, redirect } from '@tanstack/react-router'

/** Activity logs are admin-only; customer panel route is disabled. */
export const Route = createFileRoute('/_authenticated/customer/activity-logs')({
  beforeLoad: () => {
    throw redirect({ to: '/customer', replace: true })
  },
})
